import React from "react";
import styles from "./servicos_daniel__adamo.module.scss";
import {
    Building2,
    Scale,
    BookOpen,
    ShoppingCart,
    Laptop,
    Briefcase,
    Users,
    FileCheck,
    Home,
    Gavel,
    ArrowLeft,
} from "lucide-react";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import { Link } from "react-router-dom";
import logoImg from "./src/logo-adamo-salomao.png";

const whatsappLink = (servico: string) =>
    `https://wa.me/5517981339545?text=Olá! Vim pelo seu cartão digital e gostaria de saber mais sobre ${encodeURIComponent(
        servico
    )}...`;

const Servicos_daniel__adamo: React.FC = () => {
    return (
        <div className={styles.servicos_daniel__adamo}>
            {/* Header */}
            <div className={styles.header}>
                <Link to="/daniel__adamo" className={styles.backButton}>
                    <ArrowLeft />
                </Link>
                <img src={logoImg} alt="Logo Adamo & Salomão" className={styles.logo} />
            </div>

            {/* Serviços */}
            <div className={styles.services}>
                <div className={styles.card}>
                    <Building2 className={styles.icon} />
                    <h3>Direito Administrativo</h3>
                    <p>Assessoria em licitações, contratos administrativos e relações com órgãos públicos.</p>
                    <a href={whatsappLink("Direito Administrativo")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Scale className={styles.icon} />
                    <h3>Direito Civil</h3>
                    <p>Soluções jurídicas em contratos, responsabilidade civil e direitos da personalidade.</p>
                    <a href={whatsappLink("Direito Civil")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <BookOpen className={styles.icon} />
                    <h3>Direito Constitucional</h3>
                    <p>Defesa de direitos fundamentais e questões relacionadas à Constituição Federal.</p>
                    <a href={whatsappLink("Direito Constitucional")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <ShoppingCart className={styles.icon} />
                    <h3>Direito do Consumidor</h3>
                    <p>Proteção dos direitos do consumidor em relações de consumo e práticas comerciais.</p>
                    <a href={whatsappLink("Direito do Consumidor")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Laptop className={styles.icon} />
                    <h3>Direito Digital</h3>
                    <p>Consultoria em crimes virtuais, proteção de dados e relações jurídicas no ambiente digital.</p>
                    <a href={whatsappLink("Direito Digital")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Briefcase className={styles.icon} />
                    <h3>Direito Empresarial</h3>
                    <p>Assessoria completa para empresas em questões contratuais, societárias e de governança corporativa.</p>
                    <a href={whatsappLink("Direito Empresarial")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Users className={styles.icon} />
                    <h3>Direito de Família e Sucessões</h3>
                    <p>Acompanhamento em divórcios, inventários, testamentos e planejamento sucessório.</p>
                    <a href={whatsappLink("Direito de Família e Sucessões")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <FileCheck className={styles.icon} />
                    <h3>Direito Previdenciário</h3>
                    <p>Assessoria em aposentadorias, benefícios do INSS e revisões previdenciárias.</p>
                    <a href={whatsappLink("Direito Previdenciário")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Home className={styles.icon} />
                    <h3>Direito Real</h3>
                    <p>Consultoria em questões de propriedade, posse, usucapião e direitos reais.</p>
                    <a href={whatsappLink("Direito Real")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Gavel className={styles.icon} />
                    <h3>Direito do Trabalho</h3>
                    <p>Assessoria preventiva e contenciosa em relações de trabalho e direito sindical.</p>
                    <a href={whatsappLink("Direito do Trabalho")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <div className={styles.footerLinks}>
                    <a
                        href="https://www.instagram.com/daniel__adamo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon color="#DE8043" height="28" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/ZsHhCChuiD5pWZQFA"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon color="#DE8043" height="36" />
                    </a>
                </div>
            </div>

            {/* Botão WhatsApp flutuante */}
            <a
                href="https://wa.me/5517981339545?text=Olá! Vim pelo seu cartão digital e gostaria de mais informações..."
                className={styles.whatsappFloat}
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsappIcon color="#fff" />
            </a>
        </div>
    );
};

export default Servicos_daniel__adamo;
